import { Component, OnInit, ViewChild } from '@angular/core';
import { Part } from 'app/core/model/entity-model';
import { DxDataGridComponent } from 'devextreme-angular';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { GenesisUnitOfWork } from '../../core/core.module';

@Component({
    selector: 'app-part-dialog',
    templateUrl: './part-dialog.component.html',
    styleUrls: ['./part-dialog.component.scss'],
    standalone: false
})
export class PartDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    title: string = 'Parts';
    partIds: number[];
    parts: Part[];

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork) {}

    async ngOnInit() {
        this.parts = (await this.uow.parts.byIds(this.partIds, 'purchaseOrderLines.purchaseOrder, vendor')) as Part[];
    }

    rowDoubleClick(e) {
        if (!e.data || !e.data.id) return;
        this.result.next({ success: true, value: e.data.id });
    }

    async select() {
        const selectedRow = (await this.dataGrid.instance.getSelectedRowsData()) as Part[];
        if (selectedRow.length === 0) return;
        this.result.next({ success: true, value: selectedRow[0].id });
    }

    close() {
        this.result.next(false);
    }
}
